export interface Testimonial {
  role: string
  location: string
  text: string
  /** true until replaced with verified customer feedback */
  isSample: boolean
}

// Placeholder copy for layout only — replace with verified customer feedback before publication
// and set isSample to false.
export const shortTestimonials: Testimonial[] = [
  {
    role: 'Home Grower',
    location: 'United States',
    text: 'What I like most is that I don’t have to search for different answers every time I want to check something. The system shows me visually what to look at, what to measure and what to do next.',
    isSample: true,
  },
  {
    role: 'Hydroponics Beginner',
    location: 'United Kingdom',
    text: 'I wanted to start growing food at home but nutrients, pH, EC and the different systems felt overwhelming. Having everything organized visually made the whole process much easier to understand.',
    isSample: true,
  },
  {
    role: 'Home Hydroponic Grower',
    location: 'Canada',
    text: 'The crop guides and troubleshooting sections are what I use the most. Instead of guessing when a plant looks wrong, I now have a clear process for checking the system.',
    isSample: true,
  },
]
